import { Directive, ElementRef, Renderer2, Input, OnInit} from '@angular/core';
import {ProductsService} from '../services/products.service';

@Directive({
  selector: '[appAutochecked]'
})
export class AutocheckedDirective implements OnInit {
  storedCart = [];
  addOns1 = [];
  constructor(private renderer: Renderer2, private el:ElementRef, private prodObj:ProductsService) {}

  ngOnInit(){
    var addonName = this.el.nativeElement.getAttribute('adonName');
    var adonId = this.el.nativeElement.getAttribute('adonid');
    var valueName = this.el.nativeElement.getAttribute('valuename');
    var valueId = this.el.nativeElement.getAttribute('valueid');
    var productId = this.el.nativeElement.getAttribute('pid');
    var addonPrice = this.el.nativeElement.value;
    var addonQty = this.el.nativeElement.getAttribute('qty');

    this.storedCart = JSON.parse(localStorage.getItem("cartData"));

    if(this.storedCart != null && this.storedCart.length > 0){
      for(var a=0; a < this.storedCart.length; a++){
        if(this.storedCart[a].pId == productId){
            if(this.storedCart[a].addons.length > 0){
              for(var b=0; b < this.storedCart[a].addons.length; b++){
               if(this.storedCart[a].addons[b].valueid == valueId){
                if(productId != null){
                  this.addOns1['orderitem_id'] = productId;
                  this.addOns1['addonname'] = addonName;
                  this.addOns1['addonid'] = adonId;
                  this.addOns1['valuename'] = valueName;
                  this.addOns1['valueid'] = valueId;
                  this.addOns1['addonprice'] = addonPrice; 
                  this.renderer.setProperty(this.el.nativeElement, 'checked', true);
                  this.prodObj.adoncartArr.emit(this.addOns1);
                }
                 
               }
              }
              
            }
        }
      }
      
    }
  }
  

}
